module.exports = "## Badge\n\nThis component generates a small badge to the top-right of its child(ren).\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Badge/README.md
 ** module id = 941
 ** module chunks = 0
 **/